import { z } from "zod";

/**
 * UC-006 Mikroskupina dissolve form schema (Phase 28 / Milestone 20.1).
 *
 * 3-stupňový Confirm Dialog (princip #5 — adoption over features; anti-accidental
 * destructive action):
 *   Stupeň 1: info — žádné fields, jen pokračovací tlačítko.
 *   Stupeň 2: `reason` — povinný textový důvod min 10 znaků (audit log entry).
 *   Stupeň 3: `confirmPhrase` — exact match na "ZRUŠIT" (case-sensitive,
 *     diakritika preservovaná) per princip #5 anti-accidental destructive.
 *
 * Po úspěšném dokončení voláme `POST /api/tenant/microgroups/{id}/dissolve`
 * s payload { reason, confirm_phrase }; backend (Phase 19) validuje
 * exact-match a INSERTuje `card_invalidation` rows pro všechny historical
 * členy (R-040 / F11 48h SLA).
 */

export const MICROGROUP_DISSOLVE_PHRASE = "ZRUŠIT";

// Schema uchovává hodnotu jako `string` (RHF seeduje empty); superRefine
// vynucuje exact-match runtime per princip #5 — používáme `superRefine`,
// protože Zod 4 `refine` s type predicate narrowí typ a způsobí TS chyby v RHF.
export const microgroupDissolveSchema = z.object({
  reason: z
    .string()
    .trim()
    .min(10, "Důvod musí mít alespoň 10 znaků (audit log entry)."),
  confirmPhrase: z.string().superRefine((val, ctx) => {
    if (val !== MICROGROUP_DISSOLVE_PHRASE) {
      ctx.addIssue({
        code: "custom",
        message: `Pro potvrzení musíte napsat přesně „${MICROGROUP_DISSOLVE_PHRASE}".`,
      });
    }
  }),
});

export type MicrogroupDissolveInput = z.infer<typeof microgroupDissolveSchema>;

export interface MicrogroupDissolveApiPayload {
  reason: string;
  confirm_phrase: string;
}

export function toMicrogroupDissolveApiPayload(
  input: MicrogroupDissolveInput,
): MicrogroupDissolveApiPayload {
  return {
    reason: input.reason,
    confirm_phrase: input.confirmPhrase,
  };
}

export function isDissolvePhraseValid(input: string): boolean {
  return input === MICROGROUP_DISSOLVE_PHRASE;
}
